import DataTable from "components/Core/DataTable";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import { Row, Col, FormGroup, Label, Input,ModalFooter,
	Modal,
	ModalHeader,
	ModalBody, Button } from "reactstrap";
import Notify from "lib/Utils/Alert";
import Purchaser from "../../../lib/Core/Backend/Controllers/Purchaser";
import ShoppingCartController from "../../../lib/Core/Backend/Controllers/ShoppingCartPurchaseOrder";
import useCatalogs from "hooks/useCatalogs";
import Spinner from 'react-bootstrap/Spinner';
import Utils from "lib/Utils/Utils";

const PurchaseForm = ({
	name,
	setPurchaseOrder,
	setPurchaseOrderDetails,
	loggedInPurchaser,
	token,
	currencies,
	onReferenceValueChange,
	orderNewData,
	showInitial,
	handleReset,
	
}) => {
	
	
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
	const purchaserShoppingCart = useMemo(() => new ShoppingCartController(token), [token]);

	const { availableCards } = useCatalogs();

	const dollarUSLocale = Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	});
	const purchaseTable = useRef();
	const alert = useRef();
	const [date, setdate] = useState(null);
	const [quantityInput, setQuantityInput] = useState(0);
	const [amountInput, setAmountInput] = useState(0);
	const [purchaseSubtotal, setPurchaseSubtotal] = useState(0);
	const [purchaseTotal, setPurchaseTotal] = useState(0);
	const [cardTypes, setCardTypes] = useState([]);
	const [brands, setBrands] = useState([]);
	const [showAmountField, setShowAmountField] = useState(false);
	const [brandsLoading, setBrandsLoading] = useState(true);
	const [cardsLoading, setCardsLoading] = useState(true);
	const [orderreferenceValue, setOrderReferenceValue] = useState("")
	const [platForm,setPlatForm] = useState("Purchaser")
	const [currency, setCurrency] = useState('');
	const [removeCardOpen,setRemoveCardOpen] = useState(false);
	const [rowData,setRowData] = useState()
	const [addLoader,setAddLoader] = useState(false);
	const [selectedBrand, setSelectedBrand] = useState(null);
	const [cardTypeValue,setCardTypeValue] = useState(null);


	const toggleRemoveCard = () => setRemoveCardOpen(!removeCardOpen)
	const header = [
		{ title: "Card Type", data: "cardType", sortable: true, searchable: false },
		{
			title: "Face value.",
			data: "faceValueDisplay",
			sortable: true,
			searchable: false,
		},
		// {
		// 	title:"Reference",
		// 	data:"orderRef",
		// 	sortable: true,
		// 	searchable: false,
		// },
		{ title: "Quantity", data: "quantity", sortable: true, searchable: false },
		{title:"Currency",data:"currency",sortable: true, searchable: false},
		{ title: "Discount", data: "purchaseDiscount", sortable: true, searchable: false },
		{ title: "Fees", data: "purchaseFee", sortable: true, searchable: false },
		{ title: 'Subtotal Face Value', data: 'subtotalGiftCard', sortable: true, searchable: false },
		{
			title: "Subtotal",
			data: "subtotalDisplay",
			sortable: true,
			searchable: false,
		},
	];

	useEffect(()=>{
		
		if(!showInitial){
			const brandvalue = {
				value: orderNewData?.brandId,
				label:orderNewData?.brandName
			}
			setSelectedBrand(brandvalue)
			setCurrency(orderNewData?.currency)
			if (orderNewData?.id && orderNewData?.productName) {
				setCardsLoading(false)
				const cardType = {
					value: orderNewData.id,
					label: orderNewData.productName,
					amount: orderNewData.amount || 0, 
				};
				if(orderNewData?.amount == 0){
					setShowAmountField(true);
				}else{
					setShowAmountField(false);
				}
				setCardTypeValue(cardType);
			}
		
		}
	
	},[orderNewData,])

	const brandSelect = useRef();
	const cardTypeSelect = useRef();
const AddLoaderFile = () =>{
	setTimeout(() => {
		setAddLoader(false)
	}, 1500);
}
	const addToOrder = (e) => {
		setAddLoader(true)
		e.preventDefault();


		if (brandSelect.current.getValue().length === 0) {
			Notify(alert, "danger", "Please select a brand");
			AddLoaderFile()
			return;
		}

		if (cardTypeSelect.current.getValue().length === 0) {
			Notify(alert, "danger", "Please select a cardType");
			AddLoaderFile()
			return;
		}

		if (showAmountField) {
			if (amountInput < cardTypeSelect.current.getValue()[0].minAmount) {
				Notify(
					alert,
					"danger",
					`Value should be more than ${cardTypeSelect.current.getValue()[0].minAmount
					}`
				);
				AddLoaderFile()
				return;
			}
			if (amountInput > cardTypeSelect.current.getValue()[0].maxAmount) {
				Notify(
					alert,
					"danger",
					`Value should be less than ${cardTypeSelect.current.getValue()[0].maxAmount
					}`
				);
				AddLoaderFile()
				return;
			}
			if (isNaN(quantityInput)) {
				Notify(alert, "danger", "Value should be a number");
				AddLoaderFile()
				return;
			}
		}

		if (quantityInput <= 0) {
			Notify(alert, "danger", "Quantity should be more than 0");
			AddLoaderFile()
			return;
		}

		if (isNaN(quantityInput)) {
			Notify(alert, "danger", "Quantity should be a number");
			AddLoaderFile()
			return;
		}


		let cardTypeInput = cardTypeSelect.current.getValue()[0];

        let cardValue = cardTypeInput.amount !== 0 ? cardTypeInput.amount : amountInput
        
      purchaserShoppingCart.addItem(cardValue, cardTypeInput.value, quantityInput, cardTypeInput.amount === 0, orderreferenceValue, (response) => {
			if (response && !response.error) {
				drawOrderDetails(response)
				setPurchaseOrder({
					name: name,
					...response
				});
				localStorage.setItem("AddItem",JSON.stringify(response?.items?.length))
				AddLoaderFile()
			} else if (response.errorMessage) {
				Notify(alert, "danger", response.errorMessage);
				AddLoaderFile()
			} else {
				Notify(alert, "danger", response.errorCode || 'Error adding item')
				AddLoaderFile()
			}
		})

		setPurchaseOrderDetails(
			purchaseTable.current.dataTable.rows().data().map(detail => ({
				amount: detail.subtotal,
				brandId: detail.brandId,
				cardTypeId: detail.cardTypeId,
				quantity: detail.quantity,
				variable: detail.cardTypeAmount === 0,
				faceValue: detail.faceValue,
			}))
		);
		cardTypeSelect.current.clearValue();
		brandSelect.current.clearValue();
		setQuantityInput(0);
		setAmountInput(0);
		setShowAmountField(false);
		onDraw();
	};

	const drawOrderDetails = (data) => {
		const orderRef = data.orderReference;
		const purchaseItems = data.items.map(item => {
			const card = availableCards.find(cardtype => cardtype.id === item.giftCardTypeId)
			const currency = currencies.find(currency => currency.id === item.currencyId)
			const currencyFormat = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: currency?.code ?? 'USD'
			})

			return {
				...item,
				cardType: card ? card.productName : `Not available`,
				faceValue: item.amount,
				currency: currency?.code ?? 'N.A.',
				faceValueDisplay: currencyFormat.format(item.amount),
				subtotalGiftCard: currencyFormat.format(item.subtotal),
				subtotalDisplay: currencyFormat.format(item.total),
				name: card ? card.productName : `Not available`,
				purchaseDiscount: Utils.percentFormat(item.purchaseDiscount / 100),
				purchaseFee: item.purchaseFeeType === "PERCENTAGE" ? (item.purchaseFee.toFixed(2)) + '%' : currencyFormat.format(item.purchaseFee),
				orderRef: orderRef
			}
		})
		setPurchaseOrderDetails(purchaseItems);
		setPurchaseSubtotal()
		purchaseTable.current.dataTable.clear().rows.add(purchaseItems).draw();
	}

	const handleBrandChange = (input) => {
		if (input) {
			const value = {
				value:input.id,
				label: input.label
			}
			setSelectedBrand(value)
			cardTypeSelect.current.clearValue();
			setCardTypes([]);
			setCardTypeValue([])
			setCardsLoading(true);
			// setCardTypes(
			// 	availableCards
			// 		.filter((card) => card.brandId === parseInt(input.value))
			// 		.map((filteredCard) => ({
			// 			...filteredCard,
			// 			value: filteredCard.id,
			// 			label: `${filteredCard.productName}`,
			// 		}))
			// );
			let normCheck = availableCards
				.filter((card) => card.brandId === parseInt(input.value))
				.map((filteredCard) => ({
					...filteredCard,
					value: filteredCard.id,
					label: `${filteredCard.productName}`,
				}));				
			let giftData;
			const fetchData = async () => {
				try {
					const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}private/backoffice/giftcard/type/supplier/brand/${loggedInPurchaser}/${input.value}`, {
						headers: {
							Authorization: `${token}`
						}
					});
					const data = await response.json();
					let currencyData = data?.length > 0 && data[0]?.currency;
					setCurrency(currencyData)
					giftData = data;
				} catch (error) {
					console.error('Error:', error);
				}
			};

			fetchData().then(() => {

				const filteredData = normCheck.filter(item1 =>
					giftData.some(item2 => item1.value === item2.id)
				);

				setCardTypes(filteredData);
			})

			setCardsLoading(false);
		} else {
			cardTypeSelect.current.clearValue();
			setCardTypes([]);
			setCardsLoading(true);
			setSelectedBrand([])
		}
	};

	const handleCardTypeChange = (input) => {
		
		
		if (input) {
          const selected = {
				value: input.id,
				label: input.label,
				amount: input.amount, 
			};
			setCardTypeValue(selected)

			if (input.amount === 0) {
				setShowAmountField(true);
			} else {
				setShowAmountField(false);
			}
		} else {
			setShowAmountField(false);
			setCardTypeValue([])
		}
	};

	const handlePurchaseChange = (input) => {
		if (input.target.name === "amount") {
			setAmountInput(parseFloat(input.target.value, 10));
		} else if (input.target.name === "quantity") {
			setQuantityInput(parseInt(input.target.value, 10));
		}
	};
	const handlePurchaseOrder = (e) => {
		const newValue = e.target.value
		setOrderReferenceValue(newValue)
		onReferenceValueChange(newValue)
	}

	const removeFromOrder = (row) => {
		toggleRemoveCard();
		setRowData(row);
	
	};

	const confirmDelete = () =>{
		purchaserShoppingCart.removeItem(rowData.data().id, () => {
			purchaserShoppingCart.getCart(response => {
				if (response && !response.error) {
					
					
					localStorage.setItem("AddItem",JSON.stringify(response?.items?.length))
					drawOrderDetails(response)
					setOrderReferenceValue(response?.orderReference)
					setPurchaseOrder({
						name: name,
						...response
					});
					toggleRemoveCard()
				} else {
					Notify(alert, "danger", response.errorMessage || response.errorCode || 'Error adding item');
				}
			})
		})

	}

	const onRowCreated = (row) => {
		row.classList.add("text-center");
	};

	const onDraw = () => {
		if (purchaseTable.current) {
			if (purchaseTable.current.dataTable.rows().data()) {
				let total = purchaseTable.current.dataTable
					.rows()
					.data()
					.reduce((a, b) => {
						return a + b.total;
					}, 0);

				let subTotal = purchaseTable.current.dataTable.rows().data()
					.reduce((a, b) => {
						return a + b.subtotal;
					}, 0);

				setPurchaseTotal(dollarUSLocale.format(total));
				setPurchaseSubtotal(dollarUSLocale.format(subTotal))
			} else {
				setPurchaseSubtotal('$0.00')
				setPurchaseTotal('$0.00');
			}
		}
	};

	useEffect(() => {
		setBrandsLoading(true);
		purchaserCtl.availableBrands(loggedInPurchaser, (data) => {
			if (data && !data.error) {
				setBrands(
					data.brands
						.sort((a, b) => a.name.localeCompare(b.name))
						.map((brand) => {
							brand.label = brand.name;
							brand.value = brand.id;
							return brand;
						})
				);
				setBrandsLoading(false);
			} else {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			}
		});

		onDraw();
	}, []);

	useEffect(() => {
		purchaserShoppingCart.getCart(response => {
			if (response && !response.error) {
				setOrderReferenceValue(response?.orderReference)
				drawOrderDetails(response)
				setPurchaseOrder({
					name: name,
					...response
				});
			} else {
				Notify(alert, "danger", response.errorMessage || response.errorCode || 'Error adding item');
			}
		})
	}, []);

	useEffect(() => {
		let today = new Date();
		let dd = String(today.getDate()).padStart(2, "0");
		let mm = String(today.getMonth() + 1).padStart(2, "0");
		let yyyy = today.getFullYear();

		today = mm + "-" + dd + "-" + yyyy;
		setdate(today);
	}, []);

	return (
		<>
			<NotificationAlert ref={alert} />
			<Row className="justify-content-center">
				<Col md={7}>
					<legend className="text-center">{name}</legend>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col md={7}>
					<legend className="text-center">{date ? date : ''}</legend>
				</Col>
			</Row>
			<Row className=" mx-lg-6 mx-xl-8" >
				<Col lg={6} xl={4}>
					<FormGroup>
						<Label for="purchaseOrderRefernce">Order Reference</Label>
						<Input
							id="purchaserOrder"
							type="text"
							name="amount"
							value={orderreferenceValue}
							onChange={handlePurchaseOrder}
						/>
					</FormGroup>
				</Col>
				<Col lg={6} xl={4}></Col>
			</Row>

			<Row className="justify-content-center mt-lg-5">
				<Col lg={3}>
					<FormGroup>
						<Label for="purchaseFormBrand">Brand</Label>
						<Select
							id="purchaseFormBrand"
							ref={brandSelect}
							options={brands}
							value={selectedBrand}
							onChange={handleBrandChange}
							isLoading={brandsLoading}
							isClearable={true}
							isDisabled={!showInitial}
						/>
					</FormGroup>
				</Col>
				<Col lg={1}>
					<FormGroup>
						<Label for="purchaseFormCurrency">Currency</Label>
						<Input
							id="purchaseFormCurrency"
							type="text"
							name="currency"
							value={currency}
							disabled={!showInitial}
						/>
					</FormGroup>
				</Col>

				<Col lg={3}>
					<FormGroup>
						<Label for="purchaseFormCardType">Card Type</Label>
						<Select
							id="purchaseFormCardType"
							ref={cardTypeSelect}
							options={cardTypes}
							value={cardTypeValue}
							onChange={handleCardTypeChange}
							isLoading={cardsLoading}
							isClearable={true}
						/>
					</FormGroup>
				</Col>
				{showAmountField && (
					<Col lg={2}>
						<FormGroup>
							<Label for="purchaseFormAmount">Value</Label>
							<Input
								id="purchaseFormAmount"
								type="number"
								name="amount"
								value={amountInput}
								onChange={handlePurchaseChange}
							/>
						</FormGroup>
					</Col>
				)}
				<Col lg={2}>
					<FormGroup>
						<Label for="purchaseFormQuantity">Quantity</Label>
						<Input
							id="purchaseFormQuantity"
							type="number"
							name="quantity"
							value={quantityInput}
							onChange={handlePurchaseChange}
						/>
					</FormGroup>
				</Col>
				<Col md='auto'>
					<FormGroup className="mt-1">
						<Button
							className="mt-lg-4 btn btn-primaryTwo"
							id="add-btn"
							type="button"
							onClick={addToOrder}
							disabled={addLoader}
						>
							{!addLoader &&"Add"}
							{
								addLoader && <Spinner
								as="span"
								animation="border"
								size="sm"
								role="status"
								aria-hidden="true"
								style={{
								  margin: "0px 8px"
								}}
							  />
							}
						</Button>
					</FormGroup>
				</Col>
				<Col md="auto">
				{!showInitial ? 
				<FormGroup className="mt-1">
				<Button onClick={handleReset} className="mt-lg-4 btn btn-primaryTwo" type="button">Reset</Button>
				</FormGroup>
				:""
				}
				
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col sm='auto'>
				<div className="table-responsive">
					<DataTable
						className="no-bottom-radius j_add_order_table"
						ref={purchaseTable}
						columns={header}
						data={null}
						addRemoveButton={{ callback: removeFromOrder }}
						options={{
							createdRow: onRowCreated,
							drawCallback: onDraw,
							dom: "tr",
							pageLength: -1,
							scrollY: '35vh',
						}}
					/>
					</div>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<div className="col-sm-10">
					<div
						className="rounded-bottom pr-1"
						style={{ width: "100%", height: "100%" }}
					>
						<p className="py-3 my-0 mr-5 pr-5 text-right"><span className="mr-4 font-weight-bold">Subtotal</span>{purchaseSubtotal}</p>
						<p className="py-3 my-0 mr-5 pr-5 text-right">
							<span className="mr-4 font-weight-bold">Total</span>
							{purchaseTotal}
						</p>
					</div>
				</div>

			</Row>
			<Modal
				isOpen={removeCardOpen}
				toggle={toggleRemoveCard}
				backdrop="static"
				centered={true}
			>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleRemoveCard}>
					<p style={{fontSize:"20px",fontWeight:"500",color:"white"}}className="mb-0">Remove Card Type</p>
				</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the selected card?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleRemoveCard}>
						Cancel
					</Button>{" "}
					<Button type="button" className="btn btn-primaryTwo" onClick={confirmDelete}>
						Yes
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};

export default PurchaseForm;
